import { render, staticRenderFns } from "./Tema3.vue?vue&type=template&id=2cf8c95c&scoped=true&lang=pug&"
import script from "./Tema3.vue?vue&type=script&lang=js&"
export * from "./Tema3.vue?vue&type=script&lang=js&"
import style0 from "./Tema3.vue?vue&type=style&index=0&id=2cf8c95c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf8c95c",
  null
  
)

export default component.exports